import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper
  },
  // Same three-column form grid as ProviderBasicInfo — see
  // docs/admin-panel/portal-ux-conventions.md section 5.
  fields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  }
}))

export default useStyles
